import { reduceAction } from '../helpers';

import types from './types';

export const initialState = () => ({
    addresses: [],
    billingAddresses: [],
    loading: false,
    message: {
        messageType: null,
        wasShown: false,
    },
    addressBookType: '',
    selectedAddressId: null,
    currentDeliveryAddressId: null,
    currentBillingAddressId: null,
    invalidAddress: false,
    addressToRemove: null,
});

const reducers = (state = initialState(), action) => {
    switch (action.type) {
        case types.SET_ADDRESSES:
            return {
                ...state,
                addresses: (action.payload && action.payload.addresses) || [],
            };

        case types.SET_BILLING_ADDRESSES:
            return {
                ...state,
                billingAddresses: (action.payload && action.payload.addresses) || [],
            };

        case types.SET_LOADING:
            return reduceAction(state, 'loading', !!action.payload);

        case types.SET_INITIAL:
            return initialState();

        case types.SET_SUCCESS_ADDED_MESSAGE:
            return {
                ...state,
                message: { wasShown: false, messageType: 'added' },
            };

        case types.SET_SUCCESS_REMOVED_MESSAGE:
            return {
                ...state,
                message: { wasShown: false, messageType: 'removed' },
            };

        case types.SET_SUCCESS_MODIFIED_MESSAGE:
            return {
                ...state,
                message: { wasShown: false, messageType: 'modified' },
            };

        case types.SET_SUCCESS_SET_DEFAULT_MESSAGE:
            return {
                ...state,
                message: { wasShown: false, messageType: 'setDefault' },
            };

        case types.REMOVE_MESSAGE:
            return {
                ...state,
                message: { wasShown: false, messageType: null },
            };

        case types.SET_WAS_SHOWN_MESSAGE:
            return {
                ...state,
                message: { ...state.message, wasShown: true },
            };

        case types.SET_ADDRESS_BOOK_TYPE:
            return reduceAction(state, 'addressBookType', action.payload);

        case types.SET_SELECTED_ADDRESS_ID:
            return reduceAction(state, 'selectedAddressId', action.payload);

        case types.SET_CURRENT_BILLING_ADDRESS_ID:
            return reduceAction(state, 'currentBillingAddressId', action.payload);

        case types.SET_CURRENT_DELIVERY_ADDRESS_ID:
            return reduceAction(state, 'currentDeliveryAddressId', action.payload);

        case types.SET_INVALID_ADDRESS:
            return reduceAction(state, 'invalidAddress', action.payload);

        case types.SET_ADDRESS_TO_REMOVE:
            return reduceAction(state, 'addressToRemove', action.payload);

        case types.SET_NEIGHBORHOOD_FIELD_INFO:
            return reduceAction(state, 'neighborhoodFieldInfo', action.payload);

        default:
            return state;
    }
};

export default reducers;
